export const CHATBOT_OPEN_EVENT = "dsite:open-chatbot";

export function openChatbot({ voice = false } = {}) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(CHATBOT_OPEN_EVENT, { detail: { voice } }));
}
